"use strict";

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _1 = require(".");

var common_1 = require("../common");

var elements_1 = require("./elements");

var CoordinateSystem = function CoordinateSystem() {
  _classCallCheck(this, CoordinateSystem);
};

exports.CoordinateSystem = CoordinateSystem;
/** Normal cartesian coordinate system */

var CartesianCoordinates =
/*#__PURE__*/
function (_CoordinateSystem) {
  _inherits(CartesianCoordinates, _CoordinateSystem);

  function CartesianCoordinates() {
    var _this;

    var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      x: 0,
      y: 0
    };

    _classCallCheck(this, CartesianCoordinates);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CartesianCoordinates).call(this));
    _this.origin = origin;
    return _this;
  }

  _createClass(CartesianCoordinates, [{
    key: "getBaseTransform",
    value: function getBaseTransform() {
      return {
        x: this.origin.x,
        y: this.origin.y,
        angle: 0
      };
    }
  }, {
    key: "transformPoint",
    value: function transformPoint(x, y) {
      return {
        x: x,
        y: y
      };
    }
  }, {
    key: "transformDirectionAtPoint",
    value: function transformDirectionAtPoint(x, y, dx, dy) {
      return {
        x: dx,
        y: dy
      };
    }
  }, {
    key: "transformPointWithBase",
    value: function transformPointWithBase(x, y) {
      return {
        x: x + this.origin.x,
        y: y + this.origin.y
      };
    }
  }, {
    key: "transformDirectionAtPointWithBase",
    value: function transformDirectionAtPointWithBase(x, y, dx, dy) {
      return {
        x: dx,
        y: dy
      };
    }
  }, {
    key: "getLocalTransform",
    value: function getLocalTransform(x, y) {
      return {
        x: x,
        y: y,
        angle: 0
      };
    }
  }]);

  return CartesianCoordinates;
}(CoordinateSystem);

exports.CartesianCoordinates = CartesianCoordinates;
var sqrt60 = Math.sqrt(60);
/** Polar coordinates. Angle is in degrees, clockwise, top is 0  */

var PolarCoordinates =
/*#__PURE__*/
function (_CoordinateSystem2) {
  _inherits(PolarCoordinates, _CoordinateSystem2);

  function PolarCoordinates() {
    var _this2;

    var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      x: 0,
      y: 0
    };
    var radial1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var radial2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var distortY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, PolarCoordinates);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(PolarCoordinates).call(this));
    _this2.origin = origin;
    _this2.radial1 = radial1;
    _this2.radial2 = radial2;
    _this2.distortY = distortY;
    return _this2;
  }

  _createClass(PolarCoordinates, [{
    key: "getBaseTransform",
    value: function getBaseTransform() {
      return {
        x: this.origin.x,
        y: this.origin.y,
        angle: 0
      };
    }
  }, {
    key: "transformRadial",
    value: function transformRadial(radial) {
      if (this.distortY) {
        return Math.sqrt(Math.max(0, (this.radial1 + this.radial2) * radial - this.radial1 * this.radial2));
      } else {
        return radial;
      }
    }
  }, {
    key: "inverseTransformRadial",
    value: function inverseTransformRadial(distance) {
      var y = distance / sqrt60;
      return y * y;
    }
  }, {
    key: "transformPoint",
    value: function transformPoint(angle, radial) {
      return {
        x: this.transformRadial(radial) * Math.sin(angle * (Math.PI / 180)),
        y: this.transformRadial(radial) * Math.cos(angle * (Math.PI / 180))
      };
    }
  }, {
    key: "transformDirectionAtPoint",
    value: function transformDirectionAtPoint(angle, radial, dx, dy) {
      var t = -angle * (Math.PI / 180);
      return {
        x: dx * Math.cos(t) - dy * Math.sin(t),
        y: dx * Math.sin(t) + dy * Math.cos(t)
      };
    }
  }, {
    key: "getLocalTransform",
    value: function getLocalTransform(angle, radial) {
      var t = angle * (Math.PI / 180);
      return {
        x: this.transformRadial(radial) * Math.sin(t),
        y: this.transformRadial(radial) * Math.cos(t),
        angle: -angle
      };
    }
  }, {
    key: "transformPointWithBase",
    value: function transformPointWithBase(angle, radial) {
      var t = angle * (Math.PI / 180);
      return {
        x: this.transformRadial(radial) * Math.sin(t) + this.origin.x,
        y: this.transformRadial(radial) * Math.cos(t) + this.origin.y
      };
    }
  }, {
    key: "transformDirectionAtPointWithBase",
    value: function transformDirectionAtPointWithBase(angle, radial, dx, dy) {
      var t = -angle * (Math.PI / 180);
      return {
        x: dx * Math.cos(t) - dy * Math.sin(t),
        y: dx * Math.sin(t) + dy * Math.cos(t)
      };
    }
  }]);

  return PolarCoordinates;
}(CoordinateSystem);

exports.PolarCoordinates = PolarCoordinates;
/** Bezier curve coordinate system. */

var BezierCurveCoordinates =
/*#__PURE__*/
function (_CoordinateSystem3) {
  _inherits(BezierCurveCoordinates, _CoordinateSystem3);

  function BezierCurveCoordinates() {
    var _this3;

    var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      x: 0,
      y: 0
    };
    var curve = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, BezierCurveCoordinates);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(BezierCurveCoordinates).call(this));
    _this3.origin = origin;
    _this3.curve = curve;
    return _this3;
  }

  _createClass(BezierCurveCoordinates, [{
    key: "getBaseTransform",
    value: function getBaseTransform() {
      return {
        x: this.origin.x,
        y: this.origin.y,
        angle: 0
      };
    }
  }, {
    key: "transformPoint",
    value: function transformPoint(x, y) {
      var frame = this.curve.getFrameAtS(x);
      return {
        x: frame.p.x + y * frame.n.x,
        y: frame.p.y + y * frame.n.y
      };
    }
  }, {
    key: "transformDirectionAtPoint",
    value: function transformDirectionAtPoint(x, y, dx, dy) {
      var frame = this.curve.getFrameAtS(x);
      return {
        x: dx * frame.t.x + dy * frame.n.x,
        y: dx * frame.t.y + dy * frame.n.y
      };
    }
  }, {
    key: "getLocalTransform",
    value: function getLocalTransform(x, y) {
      var frame = this.curve.getFrameAtS(x);
      var angle = Math.atan2(frame.t.y, frame.t.x) / Math.PI * 180;
      return {
        x: frame.p.x + y * frame.n.x,
        y: frame.p.y + y * frame.n.y,
        angle: angle
      };
    }
  }, {
    key: "transformPointWithBase",
    value: function transformPointWithBase(x, y) {
      var p = this.transformPoint(x, y);
      return {
        x: p.x + this.origin.x,
        y: p.y + this.origin.y
      };
    }
  }, {
    key: "transformDirectionAtPointWithBase",
    value: function transformDirectionAtPointWithBase(x, y, dx, dy) {
      return this.transformDirectionAtPoint(x, y, dx, dy);
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.curve.getLength();
    }
  }, {
    key: "getCurve",
    value: function getCurve() {
      return this.curve;
    }
  }]);

  return BezierCurveCoordinates;
}(CoordinateSystem);

exports.BezierCurveCoordinates = BezierCurveCoordinates;

var CoordinateSystemHelper =
/*#__PURE__*/
function () {
  function CoordinateSystemHelper(coordinateSystem) {
    _classCallCheck(this, CoordinateSystemHelper);

    this.coordinateSystem = coordinateSystem;
  }

  _createClass(CoordinateSystemHelper, [{
    key: "rect",
    value: function rect(x1, y1, x2, y2) {
      var style = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var cs = this.coordinateSystem;

      if (cs instanceof CartesianCoordinates) {
        return _1.makeRect(x1, y1, x2, y2, style);
      } else {
        var path = _1.makePath(style);

        this.lineTo(path, x1, y1, x1, y2, true);
        this.lineTo(path, x1, y2, x2, y2, false);
        this.lineTo(path, x2, y2, x2, y1, false);
        this.lineTo(path, x2, y1, x1, y1, false);
        path.closePath();
        return path.path;
      }
    }
  }, {
    key: "ellipse",
    value: function ellipse(x1, y1, x2, y2) {
      var style = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var cs = this.coordinateSystem;

      if (cs instanceof CartesianCoordinates) {
        return elements_1.makeEllipse(x1, y1, x2, y2, style);
      } else {
        var path = _1.makePath(style);

        var cx = (x1 + x2) / 2,
            cy = (y1 + y2) / 2;
        var rx = Math.abs(x2 - x1) / 2,
            ry = Math.abs(y2 - y1) / 2;
        var N = 32;

        for (var i = 0; i < N; i++) {
          var theta1 = i / N * (Math.PI * 2);
          var theta2 = (i + 1) / N * (Math.PI * 2);
          this.lineTo(path, cx + rx * Math.cos(theta1), cy + ry * Math.sin(theta1), cx + rx * Math.cos(theta2), cy + ry * Math.sin(theta2), i == 0);
        }

        path.closePath();
        return path.path;
      }
    }
  }, {
    key: "line",
    value: function line(x1, y1, x2, y2) {
      var style = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var cs = this.coordinateSystem;

      if (cs instanceof CartesianCoordinates) {
        return _1.makeLine(x1, y1, x2, y2, style);
      } else {
        var path = _1.makePath(style);

        this.lineTo(path, x1, y1, x2, y2, true);
        return path.path;
      }
    }
  }, {
    key: "lineTo",
    value: function lineTo(path, x1, y1, x2, y2, newPath) {
      var cs = this.coordinateSystem;

      if (newPath) {
        var p = cs.transformPoint(x1, y1);
        path.moveTo(p.x, p.y);
      }

      if (cs instanceof CartesianCoordinates) {
        path.lineTo(x2, y2);
      }

      if (cs instanceof PolarCoordinates) {
        path.polarLineTo(0, 0, 90 - x1, cs.transformRadial(y1), 90 - x2, cs.transformRadial(y2), false);
      }

      if (cs instanceof BezierCurveCoordinates) {
        if (Math.abs(x1 - x2) < 1e-6) {
          var _p = cs.transformPoint(x2, y2);

          path.lineTo(_p.x, _p.y);
        } else {
          var framePrevious = cs.getLocalTransform(x1, y1);
          var direction = Math.atan2(y2 - y1, x2 - x1);
          var segments = Math.max(2, Math.ceil(3 * cs.getCurve().getSegments().length * Math.abs(x2 - x1) / cs.getCurve().getLength()));

          for (var i = 1; i <= segments; i++) {
            var t = i / segments;
            var frame = cs.getLocalTransform((x2 - x1) * t + x1, (y2 - y1) * t + y1);
            var len = common_1.Geometry.pointDistance(frame, framePrevious) / 3;
            var angle1 = framePrevious.angle / 180 * Math.PI + direction;
            var angle2 = frame.angle / 180 * Math.PI + direction;
            path.cubicBezierCurveTo(framePrevious.x + Math.cos(angle1) * len, framePrevious.y + Math.sin(angle1) * len, frame.x - Math.cos(angle2) * len, frame.y - Math.sin(angle2) * len, frame.x, frame.y); // path.lineTo(frame.x, frame.y);

            framePrevious = frame;
          }
        }
      }
    }
  }]);

  return CoordinateSystemHelper;
}();

exports.CoordinateSystemHelper = CoordinateSystemHelper;